import { UiText } from 'components/UiText/UiText';
import { StyledContainer } from './styles';
import fileNotFoundIcon from 'assets/images/FileNotFound.svg';
import fileWarningIcon from 'assets/images/FileWarning.svg';

type TEmptyStateProps = {
  title: string;
  subtitle?: string;
  hasMarginTop?: boolean;
  icon?: 'primary' | 'secondary';
};

const EmptyStateComponent = ({
  title,
  subtitle,
  hasMarginTop,
  icon,
}: TEmptyStateProps) => {
  return (
    <StyledContainer hasMarginTop={hasMarginTop}>
      <img src={icon === 'secondary' ? fileWarningIcon : fileNotFoundIcon} />
      <UiText size="lg" style={{ marginBottom: '1rem' }}>
        {title}
      </UiText>
      {subtitle && (
        <UiText size="sm" color="gray">
          {subtitle}
        </UiText>
      )}
    </StyledContainer>
  );
};

export { EmptyStateComponent as EmptyState };
export default EmptyStateComponent;
